import { AlkLogger } from '@alk/core';
import { IBrandingService } from './branding.interface';
import { injectable } from 'inversify';

@injectable()
export class BrandingMock implements IBrandingService {
    setup(): Promise<void> {
        AlkLogger.debug('[BrandingMock#setup]');

        return Promise.resolve();
    }
}
